import React from "react";
import { slide as Menu } from "react-burger-menu";
import "./menu.css"

export default props => {
    return (
        <Menu {...props} right>
            <a className="menu-item" href="/about">
            About
            </a>
    
            <a className="menu-item" href="/tour">
            Tour
            </a>
    
            <a className="menu-item" href="/book">
            Order the Book
            </a>

            <a className="menu-item" href="/contact">
            Contact
            </a>
        </Menu>
    );
  };